import React, { useEffect, useRef, useState } from 'react';
import { Button, DatePicker, Form, Input, Select } from 'antd';
import Vehicle from '../../classes/vehicle';
import SimpleStruct from '../../classes/simple-struct';
import { Utils } from '../../tools/utils';
import { FormInstance } from 'antd/lib/form';
import { StringFormats } from '../../config/config';
import { useTranslation } from 'react-i18next';
import { useStore } from 'store';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const { shortDateFormat } = StringFormats;
const { Option } = Select;
const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
};

interface IProps {
    data: Vehicle;
    formIsValid: (isValid: boolean, values?: any) => void;
    nextStep: () => void;
}

const VehicleForm = (props: IProps) => {
    const { t } = useTranslation();
    const formRef = useRef<FormInstance>(null);
    const setLoading = useStore((state) => state.setLoading);

    const [brands, setBrands] = useState<SimpleStruct[]>([]);
    const [colors, setColors] = useState<SimpleStruct[]>([]);

    const onFinish = (values: any) => {
        if (document.getElementById('brand-' + values.brandId) != null)
            values.brand = document.getElementById('brand-' + values.brandId)!.getAttribute('data-brand');
        if (document.getElementById('color-' + values.colorId) != null)
            values.color = document.getElementById('color-' + values.colorId)!.getAttribute('data-color');
        props.formIsValid(true, values);
        props.nextStep();
    };

    const onFinishFailed = () => {
        props.formIsValid(false);
    };

    const onBlurLicensePlate = (value: any) => {
        formRef.current!.setFieldsValue({ licensePlate: value.target.value.toUpperCase() });
    };

    useEffect(() => {
        const getBrandsAndColors = async () => {
            setLoading(true);
            const brands = await SicuriProtettiServices.getBrands();
            const colors = await SicuriProtettiServices.getColors();
            setBrands(brands);
            setColors(colors);
            setLoading(false);
        };

        getBrandsAndColors();
        // eslint-disable-next-line
    }, []);

    const utils = new Utils();
    return (
        <Form id="vehicle-form" className={'center'} ref={formRef} onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <h2 className="font-weight-600 title-content">{t('sicuri&protetti.titles.title1')}</h2>
            <br />
            <Form.Item
                {...formItemLayout}
                name="licensePlate"
                label={t('vehicleClass.plate')}
                initialValue={props.data.licensePlate}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.licensePlateReq'),
                    },
                    /*{
                        pattern: carLicencePlatePattern,
                        message: t("errorMessages.licensePlateValid")
                    }*/
                ]}
            >
                <Input placeholder={t('vehicleClass.licensePlate')} onBlur={onBlurLicensePlate} />
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="brandId"
                label={t('vehicleClass.brand')}
                initialValue={props.data.brandId}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.brandReq'),
                    },
                ]}
            >
                <Select
                    placeholder={t('vehicleClass.brand')}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    {brands.map((brand) => (
                        <Option key={brand.value} value={brand.value} id={'brand-' + brand.value} data-brand={brand.label}>
                            {brand.label}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="model"
                label={t('vehicleClass.model')}
                initialValue={props.data.model}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.modelReq'),
                    },
                ]}
            >
                <Input placeholder={t('vehicleClass.model')} />
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="colorId"
                label={t('vehicleClass.color')}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.colorReq'),
                    },
                ]}
                initialValue={props.data.colorId}
            >
                <Select
                    placeholder={t('vehicleClass.color')}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    {colors.map((color) => (
                        <Option key={color.value} value={color.value} id={'color-' + color.value} data-color={color.label}>
                            {color.label}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            {/*
            <Form.Item
                {...formItemLayout}
                name="outfitting"
                label={t("vehicleClass.outfitting")}
                initialValue={outfitting}
                rules={[
                    {
                        required: false
                    },
                ]}
            >
                <Input placeholder={t("vehicleClass.outfitting")}/>
            </Form.Item>
            */}
            <Form.Item
                {...formItemLayout}
                name="registrationDate"
                label={t('vehicleClass.regDate')}
                initialValue={props.data.registrationDate}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.regDateReq'),
                    },
                ]}
            >
                <DatePicker format={shortDateFormat} disabledDate={utils.DisableDateOfFuture} />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" id="vehicle-submit" hidden />
            </Form.Item>
        </Form>
    );
};

export default VehicleForm;
